module.exports = __webpack_public_path__ + "media/images/unemployed_inactive-cca8fac0.svg";